import { render, staticRenderFns } from "./AddonCheckBoxField.vue?vue&type=template&id=353dbb3e&scoped=true&"
import script from "./AddonCheckBoxField.vue?vue&type=script&lang=js&"
export * from "./AddonCheckBoxField.vue?vue&type=script&lang=js&"
import style0 from "./AddonCheckBoxField.vue?vue&type=style&index=0&id=353dbb3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353dbb3e",
  null
  
)

export default component.exports